import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { RESPONSE_MESSAGE } from '../../utils/Constant';
import { toast } from 'react-toastify';
import errorService from '../../utils/ErrorPopper';

export type ErrorData = {
  code: number | null;
  data: {
    apiMessageErrorList: any[] | null;
    allowDisableRules: boolean | null;
  } | null;
  message: string | null;
  [key: string]: any;
};

const HandleErrorMessage: React.FC = () => {
  const [openPopup, setOpenPopup] = useState<boolean>(false);
  const [listErrorMessage, setListErrorMessage] = useState<string[]>([]);
  const [currentResponse, setCurrentResponse] = useState<any>(null);

  useEffect(() => {
    // Lắng nghe lỗi từ errorService
    const unsubscribe = errorService.subscribe((error: ErrorData) => {
      setCurrentResponse(error);
      generatePopupContent(error);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const handleClose = () => {
    errorService.setPopupOpen(false);
    setOpenPopup(false);
  };

  const handleContinue = () => {
    errorService.executeAction();
    handleClose();
  };

  const generatePopupContent = (response: ErrorData) => {
    let errorMessage = '';
    if (response?.data?.apiMessageErrorList?.length) {
      setListErrorMessage(response?.data?.apiMessageErrorList?.map((item: any) => item?.errorMessage));
      setOpenPopup(true);
    } else {
      errorMessage = response?.message || RESPONSE_MESSAGE.ERROR;
    }
    errorMessage && toast.warn(errorMessage);
  };

  return (
    <Modal
      show={openPopup}
      onHide={handleClose}
      centered
      animation
      className={`background__modal dialog-background`}
    >
      <Modal.Header className="header-modal" closeButton>
        <Modal.Title className="text-white text-uppercase">Thông báo</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <h5 className="m-0">
          {listErrorMessage?.map((item: any, index: number) => (
            <p key={index} className="pre-wrap">
              {item}
            </p>
          ))}
        </h5>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end p-2 border-top">
        {currentResponse?.data?.allowDisableRules && (
          <Button className="btn-fill min-w-80px" onClick={handleContinue}>
            Tiếp tục
          </Button>
        )}
        <Button className="btn-outline min-w-80px" onClick={handleClose}>
          Đóng
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default HandleErrorMessage;
